import React from "react";
import { Row, Col } from "react-flexbox-grid";
import styles from "../../styles";

import {
  TextField,
  SelectField,
  CheckBox,
  IconButton,
  If
} from "components/support";

import Icons from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";

const ConfigGeneratedField = props => (
  <section className={props.className}>
    <div className="field-item">
      <If test={!["list", "radiobutton"].includes(props.type)}>
        <Row>
          <Col xs={5}>
            <TextField
              fullWidth
              underlineShow={false}
              value={props.name}
              floatingLabelFixed
              floatingLabelText="Descrição"
              onChange={props.onNameChange}
            />
          </Col>
          <Col xs={4}>
            <SelectField
              floatingLabelFixed
              floatingLabelText="Tipo"
              value={props.type}
              onChange={props.onTypeChange}
              underlineStyle={{ bottom: "0" }}
              labelStyle={{ height: "44px" }}
              fullWidth
              options={props.options}
              disabled={!props.editable}
            />
          </Col>
          <Col xs={2}>
            <CheckBox
              checked={props.required}
              label="Obrigatório"
              otherClassName="items"
              onCheck={props.onCheck}
            />
          </Col>
          <Col xs={1}>
            <div className="delete">
              <IconButton mini icon="delete" onClick={() => props.onDelete()} />
            </div>
          </Col>
        </Row>
      </If>

      <If test={["list", "radiobutton"].includes(props.type)}>
        <Row>
          <Col xs={5}>
            <TextField
              fullWidth
              underlineShow={false}
              value={props.name}
              floatingLabelFixed
              floatingLabelText="Descrição"
              onChange={props.onNameChange}
            />
          </Col>
          <Col xs={4}>
            <SelectField
              floatingLabelFixed
              floatingLabelText="Tipo"
              value={props.type}
              onChange={props.onTypeChange}
              underlineStyle={{ bottom: "0" }}
              labelStyle={{ height: "44px" }}
              fullWidth
              options={props.options}
              disabled={!props.editable}
            />
          </Col>
          <Col xs={2}>
            <CheckBox
              checked={props.required}
              label="Obrigatório"
              otherClassName="items"
              onCheck={props.onCheck}
            />
          </Col>
          <Col xs={1}>
            <div className="delete">
              <IconButton mini icon="delete" onClick={() => props.onDelete()} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="tooltip">
              <Tooltip
                key="tooltip-right"
                title='Para campos de tipo "Lista", separe cada opção no campo "Opções" por vírgula.'
                placement="right"
              >
                <Icons className="icon">info</Icons>
              </Tooltip>
            </div>
            <TextField
              fullWidth
              underlineShow={false}
              value={props.optionsList}
              floatingLabelFixed
              floatingLabelText="Opções"
              onChange={props.onOptionsChange}
            />
          </Col>
        </Row>
      </If>
    </div>
  </section>
);

export default styles(ConfigGeneratedField);



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/manage-fields/custom-fields/config/index.jsx